<app-dropdown
  [closeMethod]="closeMethod"
  [title]="'Showing ' + notificationCount + ' notifications'"
  *ngIf="{ notificationsLoading: notificationsLoading$ | async } as loadingData"
>
  <app-loading *ngIf="loadingData.notificationsLoading"></app-loading>
  <div *ngIf="!loadingData.notificationsLoading">
    <div class="notifications">
      <div class="body">
        <ng-container
          *ngIf="{ notifications: notifications$ | async } as notifData"
        >
          <ng-container
            *ngIf="notifData.notifications.length > 0; else noNotifications"
          >
            <ng-container
              *ngFor="
                let notification of notifData.notifications;
                trackBy: trackByNotificationId
              "
            >
              <app-notification
                [notification]="notification"
              ></app-notification>
            </ng-container>
          </ng-container>
          <ng-template #noNotifications>
            <div class="no-notifications">
              {{
                "dropdown-notifications.message.no-notifications" | translate
              }}
            </div>
          </ng-template>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="view-all">
    <a [routerLink]="['analytics', 'notifications']">
      <sui-button variant="primary">
        {{ "dropdown-notifications.button.view-all" | translate }}
      </sui-button>
    </a>
  </div>
</app-dropdown>
